<template>

    <div class="menu-wrapper has-text-grey-dark">

        <div class="menu-group" style="background-color:#70d3ef;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Logic & Branching</p>
            </div>

            <div class="menu-group-items">
                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/condition')" title="Various types of conditions for if/branch">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-not-equal"></i>|<i class="fa-solid fa-equals"></i></p>
                                <p class="is-size-7 has-text-weight-bold">CONDITION</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/and')" title="If Condition A and Condition B are true">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-check-double"></i></p>
                                <p class="is-size-7 has-text-weight-bold">AND</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/or')" title="If Condition A or Condition B are true">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-check"></i></p>
                                <p class="is-size-7 has-text-weight-bold">OR</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/gate')" title="Stop the branch if the condition is true/false.">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-door-open"></i></p>
                                <p class="is-size-7 has-text-weight-bold">GATE</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/wait-for')" title="Wait for a certain amount of time before continuing">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-regular fa-clock"></i></p>
                                <p class="is-size-7 has-text-weight-bold">WAIT</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>


        <div class="menu-group" style="background-color:#9fe2fc;">

            <div class="menu-group-title">
                <p title="These split your code to do different things based on conditions you define">Quick Logic</p>
            </div>

            <div class="menu-group-items">
                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/if-true-false')" title="If the given data is true or false.">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-check"></i>|<i class="fa-solid fa-xmark"></i></p>
                                <p class="is-size-7 has-text-weight-bold">TRUE / FALSE</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item" v-if="triggerType === 'updated'">
                    <div class="big-pretty-button" @click="selected('logic/if-variable-changed')" title="If a specified variable was updated">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-check"></i></p>
                                <p class="is-size-7 has-text-weight-bold">IF DATA CHANGED</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-item">
                    <div class="big-pretty-button" @click="selected('logic/if-empty')" title="If the given data is empty">
                        <div class="p-2" style="position: absolute;">
                            <div class="is-block">
                                <p class="is-size-5"><i class="fa-solid fa-check"></i></p>
                                <p class="is-size-7 has-text-weight-bold">IF EMPTY</p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>

    </div>


</template>

<script>
export default {
    name: 'MenuTabLogic',
    props: {
        triggerType: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        selected(type) {
            this.$emit('selected', type)
        }
    }
}
</script>

<style scoped lang="scss">
.menu-wrapper {
    overflow-x: auto;
    display: flex;
}
.menu-group {
    margin: 0 10px;
    padding: 10px;
    border-radius: 6px;

    .menu-group-title {
        width:100%;
        font-weight: bold;
        font-size: 1.5rem;
    }

    .menu-group-items {
        overflow-x: auto;
        display: flex;
    }

    &:first-child {
        margin-left: auto;
    }
    &:last-child {
        margin-right: auto;
    }
}
.menu-item {
    margin: 0 10px;

    & > div {
        padding: 0;
        height: 100px;
        width: 100px;
    }
}
.big-pretty-button {
    border: 0.5px solid #4a4a4a;
}
</style>
